import React from 'react';
import { useDropzone } from 'react-dropzone';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IconButton } from '@mui/material';

const DropZoneComponent = ({onDrop,fileType}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: fileType
  });

  return (
    <div {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <IconButton>
        <AddCircleOutlineIcon
          fontSize='large'
          color='inherit'
        />
      </IconButton>
      <span>Drag & Drop or Select file</span>
      <p>Drop files here or click browse through your machine.</p>
    </div>
  );
};

export default DropZoneComponent;
